import React,{ useState ,useRef} from 'react';
import { Button,Form,Col,Row,Alert} from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Logo from '../assets/icons/logo2.jpeg';
import UserNav from './UserNav';


const InstructionsPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const candidateID = searchParams.get('id');   
    const examType = searchParams.get('exam-type');
    const [success, setSuccess] = useState('');

    const handleSubmit=() =>{
        if(examType === 'THEORY'){
            navigate(`/users-questions?id=${candidateID}`);
        }else{
            navigate(`/code-interview?id=${candidateID}`);
        }
       

    }
    const handleSubmit2=() =>{
        if(examType === 'THEORY'){
            navigate(`/UsersDemoQuestions?id=${candidateID}`,{ state: { examType: examType } });
        }else{
            navigate(`/UsersDemoQuestions?id=${candidateID}`,{ state: { examType: examType } });
        }
       

    }


    return(
        <div className='instruct-div'>
      
      <UserNav />
        
        <div >
            <div className='inst-condition-div'>
                <h1>EngageTalent.AI Test Guidelines:</h1>
                {examType === 'THEORY' && 
                     <p>
                     <strong>Question Answering: </strong>
                     Click the Mic icon and start answering.
                     </p>
                }
           
                <p>
                <strong>Zoom Call: </strong>
                You must remain on the Zoom call throughout the test.
                </p>
                <p>
                <strong>Test Environment: </strong>
                Take the test in a quiet room to avoid disturbances.
                </p>
                <p>
                <strong>Page Refresh: </strong>
                Do not refresh the test page at any time during the test.
                </p>
                <p>
                <strong>Question Navigation: </strong>
                You cannot return to or change answers for previously submitted questions.

                </p>
                <p>
                <strong>Video and Screen Sharing: </strong>
                Keep your video on and share your screen during the test.
                </p>
                <p>
                <strong>Browsing Restrictions: </strong>
                Do not open any websites or browse the internet during the test. Doing so will result in disqualification.
                </p>
                <p>
                <strong>Technical Issues: </strong>
                If you encounter internet problems or other issues, immediately inform the recruiter.

                </p>
                {examType === 'THEORY' && 
                     <p>
                     <strong>Answer Editing: </strong>
                     You cannot edit your answers after recording them. You can only clear and re-record the answer.
                     </p>
                }
           
                <p>
                <strong>Audio Requirements: </strong>
                Do not mute your audio during the exam.
                </p>
                <p>
                <strong>Timely Submission: </strong>
                Complete and submit your exam within the allotted time. Late submissions may not be considered.
                </p>

                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button variant="dark" onClick={handleSubmit} style={{ marginTop: '20px', marginRight: '10px' }}>Start Test</Button>
                    { <Button variant="dark" onClick={handleSubmit2} style={{ marginTop: '20px', marginLeft: '10px' }}>Sample Test</Button>}
                </div>

                {/* <Button variant="dark" onClick={handleSubmit} style={{ marginTop: '20px' }}>Start Test</Button>
                <Button variant="dark" onClick={handleSubmit2} style={{ marginTop: '40px' }}>Demo Test</Button> */}

            </div>
        </div>
        <footer >
      <p style={{color:'white'}}>&copy; 2024 Data Lake Solutions LLC. All rights reserved.</p>
      </footer>
        </div>
    );

}
export default InstructionsPage;